<template>
  <div class="overflow-hidden">
    <HeaderTwo/>
    <!-- hero area start -->
    <div class="fancy-hero-five">
      <div class="bg-wrapper">
        <div class="container">
          <div class="text-center row">
            <div class="col-xl-9 m-auto">
              <h1 class="heading flex align-items-center">
                <img alt=""
                     src="../assets/images/logo/cross.svg"
                     width="50"
                     height="50"
                     class="heading-icon"/>
                {{ content?.title || 'How To Pay' }}
              </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- hero area end -->
    <div class="tc-content container py-16">
      <div class="row">
        <div class="col-8 mb-50">
          <PortableText
              v-if="content?.blockText"
              :value="content.blockText"
              :components="components"
          />
        </div>
      </div>
    </div>
    <FooterSeven :dark_bg="true" :dark_btn="true" />
  </div>
</template>

<script>
import FooterSeven from "@/components/common/Footers/FooterSeven.vue";
import HeaderTwo from "@/components/common/Headers/HeaderTwo.vue";
import { PortableText } from '@portabletext/vue';
import { useHead } from '@vueuse/head';
import sanity from "../../sanity.js";

export default {
  name:'HowToPay',
  components: {
    HeaderTwo,
    FooterSeven,
    PortableText
  },
  data() {
    return {
      content: null,
    }
  },
  methods: {
    async fetchData() {
      const query = `*[_type == "generic" && slug.current == "how-to-pay"][0]{
        title,
        blockText,
        seo {
          title,
          description,
          keywords,
          ogImage {
            asset->{
              url
            }
          }
        }
      }`;
      this.loading = true;
      try {
        const content = await sanity.fetch(query);
        this.loading = false;
        this.content = content;

        // Call useHead after data is loaded
        useHead({
          title: `${content?.seo?.title || content?.title || 'How To Pay'} | Marshall Print`,
          meta: [
            { name: 'description', content: content?.seo?.description },
            { name: 'keywords', content: content?.seo?.keywords },
            // { property: 'og:title', content: content?.seo?.title },
            // { property: 'og:description', content: content?.seo?.description },
            // { property: 'og:image', content: content?.seo?.ogImage?.asset?.url },
          ]
        });
      } catch (error) {
        this.error = error;
      }
    },},
  async created() {
    await this.fetchData();
  }
}
</script>

<style lang="scss" scoped>
.strip {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0 0 5rem 0;
  width: 100%;
  background-color: var(--lightgrey);
  font-weight: bold;
  padding: 6rem 0;
}
.fancy-hero-five {
  background-color: var(--darkblue);
  margin: 8rem 0 3rem 0;
  padding: 6rem 0;
  @media (max-width: 767px) {
    margin: 5rem 0 0 0;
    padding: 4rem 0;
  }
  .heading {
    color: white;
    display: flex;
    font-size: 4rem;
    font-weight: bold;
    line-height: 4rem;
    align-items: center;
    justify-content: center;
    @media (max-width: 767px) {
      font-size: 2.5rem;
    }
    .heading-icon {
      display: block;
      margin-right: 1rem;
    }
  }
}
:deep(.tc-content h2) {
  color: var(--darkblue);
  font-size: 2.5rem;
  font-weight: bold;
  margin:0 0 1rem 0;
}
:deep(.tc-content p) {
  margin: 0 0 1rem 0;
}
:deep(.tc-content a) {
  color: var(--pink);
  font-weight: bold;
}
</style>
